import React from "react"
import { Link } from "react-router-dom"
import moment from "moment"

import styles from "./Footer.css"

const Footer = () => (
  <footer>
    <span className={styles.copyright}>Copyright &copy; {moment().year()} Webinterpret</span>
    {<Link className={styles.faq} to="/faq">FAQ</Link>}
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/shared/components/Footer/Footer.js